/** URL state of /api-access (the open tab) and /oauth/consent (the request). */
import { defineSearch, param, type RawSearch } from '@/router/search';

export const API_ACCESS_TABS = ['keys', 'apps', 'mcp', 'docs'] as const;
export type ApiAccessTab = (typeof API_ACCESS_TABS)[number];

/** `keys` is the default and never written to the URL. */
export const parseApiAccessSearch = (raw: RawSearch) => ({
  tab: param.enumValue(raw, 'tab', API_ACCESS_TABS),
});
export const apiAccessSearch = defineSearch(parseApiAccessSearch);

export const parseConsentSearch = (raw: RawSearch) => ({
  request_id: param.string(raw, 'request_id'),
});
export const consentSearch = defineSearch(parseConsentSearch);
